import cx from "classnames";
import { Form, Formik } from "formik";
import { useTranslation } from "react-i18next";

import { Button, Col, Divider, Flex, Modal, Row, Space, Tooltip } from "antd";
import { Input, RadioGroup, Select } from "components/form";


import styles from "components/elements/Modal/Modal.module.css";
import schema from "../schema/userRoleSchema";
import { InfoCircleOutlined } from "@ant-design/icons";

function ModalRole({
  width = 510,
  className = "",
  roleOptions = [],
  initialValues = {},
  isModalOpen = false,
  onSubmit = () => { },
  onCancel = () => { },
}) {
  const { t, i18n } = useTranslation();



  return (
    <Modal
      destroyOnClose={true}
      title={
        <b className={styles.infoTopic}>
          {initialValues.roleId ? t("common.edit") : t("common.create")}
        </b>
      }
      open={isModalOpen}
      onCancel={onCancel}
      className={cx(styles.customStyle, className)}
      width={width}
      footer={null}
      closable={false}
      maskClosable={false}
    >
      <Formik
        enableReinitialize
        initialValues={{ ...initialValues, defaultRoleCode: i18n.language === 'en' ? initialValues?.defaultRoleCode?.roleNameEn : initialValues?.defaultRoleCode?.roleName }}
        validationSchema={schema}
        onSubmit={onSubmit}
      >
        {({ values }) => {
          return (
            <Form>
              {/* <Divider style={{ marginTop: "12px", marginBottom: "12px" }} /> */}
              <Space
                className={styles.container}
                size={24}
                direction="vertical"
              >
                <Row gutter={[0, 12]}>
                  <Col span={24}>
                    <Input
                      name="roleName"
                      label={t('usermanagment.role_th')}
                      placeholder={t('usermanagment.role_th')}
                      size="large"
                      required={true}
                    />
                  </Col>
                  <Col span={24}>
                    <Input
                      name="roleNameEn"
                      label={t('usermanagment.role_en')}
                      placeholder={t('usermanagment.role_en')}
                      size="large"
                      required={true}
                    />
                  </Col>
                  {/* {!values.roleId && */}
                  <Col span={24}>
                    <Select
                      name="defaultRoleCode"
                      label={t('translation.apply-to-default-permissions-of')}
                      placeholder={t('translation.usemanagement.please-select-0')}
                      size="large"
                      options={roleOptions}
                      required={true}
                    />
                  </Col>
                  {/* } */}
                  <Col span={24} >
                    <Flex align="center" gap="8px">
                      <label >{t('translation.is-hr')}
                        <span style={{ color: "red" }}> *</span>
                      </label>
                      <Tooltip placement="bottom"
                        title={t('if-this-role-is-designated-as-hr-it-means-that-the-person-in-this-role-will-be-able-to-create-various-documents-on-behalf-of-all-employees-in-the-company-and-cancel-any-documents-requested-by-employees')}>
                        <InfoCircleOutlined />
                      </Tooltip>

                    </Flex>

                  </Col>
                  <Col span={24}>
                    <RadioGroup
                      name="roleHr"
                      required={true}
                      options={[
                        {
                          label: t('translation.yes'),
                          value: "Y",
                        },
                        {
                          label: t('translation.no'),
                          value: "N",
                        },
                      ]}
                    />
                  </Col>

                  <Col span={24}>
                    <Input
                      name="description"
                      label={t('translation.description.description_th')}
                      placeholder={t('translation.description.description_th')}
                      size="large"
                      type="textarea"
                      rows={4}
                    />
                  </Col>
                  <Col span={24}>
                    <Input
                      name="descriptionEn"
                      label={t('translation.description.description_en')}
                      placeholder={t('translation.description.description_en')}
                      size="large"
                      type="textarea"
                      rows={4}
                    />
                  </Col>
                </Row>
                <Row justify="end">
                  <Space direction="horizontal" size={12}>
                    <Button
                      key="back"
                      onClick={onCancel}
                      type="default"
                      style={{ width: "100px", height: "44px", borderRadius: "8px", padding: "8px 16px" }}
                    >
                      {t("common.cancel").toUpperCase()}
                    </Button>
                    <Button
                      type="primary"
                      htmlType="submit"
                      style={{ width: "100px", height: "44px", borderRadius: "8px", backgroundColor: "#2CADE7", padding: "8px 16px" }}
                    >
                      {t("action.submit").toUpperCase()}
                    </Button>
                  </Space>
                </Row>
              </Space>
            </Form>
          );
        }}
      </Formik>
    </Modal >
  );
}

export default ModalRole;
